/**
 * Full-page loading state.
 *
 * Lives apart from RequireAuth on purpose. RequireAuth reaches the profile
 * hook and therefore the api client and Amplify; App.tsx needs only this
 * spinner for its Suspense fallback, and importing it from RequireAuth put
 * ~172 KB of auth SDK on the critical path for visitors who never sign in.
 */
export function FullPageSpinner({ label }: { label?: string } = {}) {
  return (
    <div className="grid min-h-dvh place-items-center bg-bg">
      <div className="flex flex-col items-center gap-4">
        <span
          role="status"
          aria-label="Loading"
          className="inline-block size-10 animate-spin rounded-full border-2 border-border border-t-primary"
        />
        {label && (
          <p className="font-display text-[10px] tracking-[0.3em] text-fg-subtle uppercase">
            <span className="text-primary">//</span> {label}
          </p>
        )}
      </div>
    </div>
  )
}
